import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_GEN_AI_DEMO_ISNA_3 = {
  title:
    "Guide NOC users in taking \ncorrective actions using the \nderived insights",
  subtitle: "Gen AI Demo",
  text: "Helps NOC users in making use of generated \ninsights efficiently, thereby enabling them to \nact early in detecting and resolving potential \nnetwork issues faster.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_209"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_207"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_GEN_AI_Demo_01.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_03_bubble_part_1.png",
          imageStyle: { position: "absolute", right: "166px", top: "180px" },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_03_bubble_part_2.png",
          imageStyle: { position: "absolute", right: "232px", top: "270px" },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_03_bubble_part_3.png",
          imageStyle: { position: "absolute", right: "166px", top: "400px" },
        },
      ]}
      pageNumber={"ENG_208"}
      conversationStyle={{
        width: "auto",
        alignItems: "center",
        marginRight: "90px",
      }}
    />
  ),
};
